import { create } from "zustand";

type OrderState = {
  activeOrderId: string | null;
  selectedChanelId: string | null;
  setSelectedChanelId: (id: string) => void;
  setActiveOrderId: (id: string) => void;
  clearActiveOrderId: () => void;
};

export const useOrderStore = create<OrderState>((set) => ({
  activeOrderId: null,
  selectedChanelId: null,
  setActiveOrderId: (id) => set({ activeOrderId: id }),
  clearActiveOrderId: () => set({ activeOrderId: null }),
  setSelectedChanelId: (id) => set({ selectedChanelId: id }),
  clearSelectedChanelId: () => set({ selectedChanelId: null }),
}));
